import type { RouteRecordRaw } from 'vue-router';

export const industryRoutes: RouteRecordRaw[] = [
  {
    // Dedicated industry workspace — appears in the nav only while a template
    // with a position calculator (Windows & Doors) is active.
    path: 'industry/offer-builder',
    name: 'industry.offer-builder',
    component: () => import('./pages/WindowOfferBuilderPage.vue'),
    meta: { title: 'Offer builder', requiresAuth: true },
  },
];
